
import React, { useMemo } from 'react';

import "../../../../assets/scss/Horas Extras/PlanificacionHorasExtras.scss"
import TableServidoresPlanHE from '../PlanificacionHE/TableServidoresPlanHE';
import { DetalleServidoresProyHEDTO } from './TypesProyeccionDirectivo';
import { DetalleParametrosProyeccionHE } from 'components/Admin/Horas Extras/Parametros Horas Extras/TypesParametrosHorasExtras';
import { DetalleGrupoActividadHEDTO, NovedadesServidoresHEDTO, ParamsHorasMesPlanificacionHEDTO } from '../PlanificacionHE/TypesPlanificacionHE';
import { ChangeToPromise } from 'functions/GeneralFunctions';

export type PropsServidoresProyeccionHE = {
    estadoPlanificacion: string,
    listadoServidores: DetalleServidoresProyHEDTO[],
    recargarInformacion: () => Promise<void>
    parametrosHorasRegimenProyeccion: DetalleParametrosProyeccionHE
    novedadesServidores: NovedadesServidoresHEDTO[]
    mensajeNovedad: string
    idUnidadAprueba:number
    nombreUnidadAprueba:string
    gruposActividad: DetalleGrupoActividadHEDTO[];

    puedeRealizarAccion?: boolean
    guardarParcial: () => void
    enviarTh: () => void
    solicitarReverso: () => void
    mostrarGuardarParcial?: boolean | undefined;
    mostrarFirmaryEnviar?: boolean | undefined;
    mostrarSolicitarReverso?: boolean | undefined;

    mostrarReporteResumenProyPlanifExcel?: boolean
    loadingAccionReporteExcel?: boolean
    descargarResumenExcel?: () => Promise<void>
}



export default function ServidoresPlanificacionHE(props: PropsServidoresProyeccionHE) {


    const mapeoParametrosHorasRegimenProyeccion: ParamsHorasMesPlanificacionHEDTO[] = props.parametrosHorasRegimenProyeccion.listadoparametroshorasregimen.map((parametros, i) => {
        return {
            idheparamhorasmes: 0,
            horasExtraordinarias: parametros.horasextraordinarias ?? 0,
            horasSuplementarias: parametros.horassuplementarias ?? 0,
            horasExtraySuple: parametros.horassuplyextr ?? 0,
            idregimenlaboral: parametros.idregimenlaboral
        }
    })


    
    const realizarAcciones:boolean = ( props.puedeRealizarAccion  !== undefined && props.puedeRealizarAccion === true) || (props.puedeRealizarAccion === undefined)





    const contenidoTablaServidores = useMemo(() => {
        const contenidoServidores = (
            <TableServidoresPlanHE
                servidoresPlan={props.listadoServidores}
                recargarInformacion={props.recargarInformacion}
                paramsHorasMesPlanificacionHE={mapeoParametrosHorasRegimenProyeccion}
                novedadesServidores={props.novedadesServidores}
                estadoPlanificacion={props.estadoPlanificacion}
                mensajeNovedad={props.mensajeNovedad}
                tipo='PR'
                idUnidadAprueba={props.idUnidadAprueba}
                nombreUnidadAprueba={props.nombreUnidadAprueba}

                puedeRealizarAccion={realizarAcciones}
                guardarParcial = {props.guardarParcial}
                firmaryEnviar = {() => ChangeToPromise(props.enviarTh)}
                solicitarReverso = {props.solicitarReverso}
                mostrarGuardarParcial = {props.mostrarGuardarParcial}
                mostrarFirmaryEnviar  = {props.mostrarFirmaryEnviar}
                mostrarSolicitarReverso = {props.mostrarSolicitarReverso}

                descargarResumenExcel={ props.descargarResumenExcel}
                mostrarReporteResumenProyPlanifExcel = {props.mostrarReporteResumenProyPlanifExcel}
                gruposActividad={props.gruposActividad}

            />
        )
        if(mapeoParametrosHorasRegimenProyeccion ){
            return contenidoServidores;
        }
        
    }, [props])

    return (
        <>
            {contenidoTablaServidores}
        </>



    )
}